import * as api from '../api';

// Helper function to handle auth actions
const handleAuthAction = async (actionType, apiCall, formData, dispatch) => {
    try {
        dispatch({ type: `${actionType}_START` });
        const { data } = await apiCall(formData);
        
        // Handle token storage for signin and signup only
        if (['AUTH', 'SIGNUP'].includes(actionType)) {
            localStorage.setItem('token', data.token);
            api.setAuthToken(data.token);
        }
        
        dispatch({ 
            type: `${actionType}_SUCCESS`,
            payload: data 
        });
        
        return data;
    } catch (error) {
        // Check if we need to reauthenticate
        if (error.response?.data?.shouldReauthenticate) {
            dispatch({ type: 'LOGOUT' });
            localStorage.clear();
            window.location.href = '/auth';
            return;
        }

        dispatch({ 
            type: `${actionType}_FAIL`,
            payload: error.response?.data?.message || `${actionType.toLowerCase()} failed`
        });
        throw error;
    }
};

// Action Creators
export const signIn = (formData, navigate) => async (dispatch) => {
    try {
        dispatch({ type: 'AUTH_START' });
        const { data } = await api.signIn(formData);
        
        dispatch({ 
            type: 'AUTH_SUCCESS', 
            payload: {
                user: data.result,
                token: data.token
            }
        });

        navigate('/');
    } catch (error) {
        dispatch({ 
            type: 'AUTH_FAIL',
            payload: error.response?.data?.message || 'Something went wrong'
        });
    }
};

export const signUp = (formData, navigate) => async (dispatch) => {
    try {
        dispatch({ type: 'SIGNUP_START' });
        const { data } = await api.signUp(formData);
        
        // Explicitly clear any existing token and ensure user is not authenticated
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('profile');
        api.removeAuthToken();
        
        // Force a page reload to clear all authentication state
        window.location.href = '/auth';
        
    } catch (error) {
        dispatch({ 
            type: 'SIGNUP_FAIL',
            payload: error.response?.data?.message || 'Something went wrong'
        });
    }
};

export const updateProfile = (formData) => async (dispatch) => {
    return handleAuthAction('UPDATE_PROFILE', api.updateProfile, formData, dispatch);
};

export const logout = () => async (dispatch) => {
    try {
        localStorage.clear();
        api.removeAuthToken();
        dispatch({ type: 'LOGOUT' });
        window.location.href = '/auth';
    } catch (error) {
        console.error('Logout error:', error);
    }
};